import '@capture/client/assets/globalStyle.scss'
import * as React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import { SuggestModernBrowser } from '@capture/client/components/Info/SuggestModernBrowser'
import { isModernBrowser } from '@capture/client/utilities/device'
import { consoleLog } from '@capture/client/utilities/logging'

consoleLog(`Launching CaptureWeb version: ${import.meta.env.VITE_VERSION}`)

if (!isModernBrowser()) {
    hydrateRoot(
        document,
        <React.StrictMode>
            <SuggestModernBrowser />
        </React.StrictMode>,
    )
} else {
    hydrateRoot(
        document,
        <React.StrictMode>
            <HydratedRouter />
        </React.StrictMode>,
    )
}
